import { AdSlot } from './ad-slot';
import { AdSlotContainerItem } from './ad-slot-container-item';

export class AdSlotContainer {
  private adSlot?: AdSlot;
  private element?: HTMLElement;
  private rendered = false;
  private index = 0;
  private items: Map<string, AdSlotContainerItem> = new Map();

  public getElement (): HTMLElement | null {
    return this.element ?? null;
  }

  public setElement (element: HTMLElement): this {
    this.element = element;
    return this;
  }

  public getIndex (): number {
    return this.index;
  }

  public setIndex (index: number): this {
    this.index = index;
    return this;
  }

  public getAdSlot (): AdSlot | null {
    return this.adSlot ?? null;
  }

  public setAdSlot (adSlot?: AdSlot): this {
    this.adSlot = adSlot;
    return this;
  }

  public isRendered (): boolean {
    return this.rendered;
  }

  public setIsRendered (rendered: boolean): this {
    this.rendered = rendered;

    if (this.element) {
      this.element.dataset[ 'index' ] = this.index.toString();
      this.element.dataset[ 'rendered' ] = rendered ? 'true' : 'false';
      delete this.element.dataset[ 'rendering' ];
    }

    return this;
  }

  public getItems (): AdSlotContainerItem[] {
    return [ ...this.items.values() ];
  }

  public setItems (items: AdSlotContainerItem[]): this {
    for (const item of items) {
      this.addItem(item);
    }

    return this;
  }

  public addItem (item: AdSlotContainerItem): this {
    if (!this.items.has(item.getId())) {
      this.items.set(item.getId(), item);
      item.setAdSlotContainer(this);
    }
    return this;
  }

  public removeItem (item: AdSlotContainerItem): this {
    if (!this.hasItem(item)) {
      return this;
    }

    if (this.items.delete(item.getId()) && item.getAdSlotContainer() === this) {
      item.setAdSlotContainer(undefined);
    }

    return this;
  }

  public hasItem (item: AdSlotContainerItem): boolean {
    return this.items.has(item.getId());
  }

  public hasItems (): boolean {
    return this.items.size > 0;
  }
}
